import { compact, flatten, groupBy, map, sumBy } from 'lodash'
import { TransferData } from '../apis/transfer.api'
import { MapCoordinate } from '../components/Map'

interface StockOnHandData {
  id: number
  item: string
  description: string
  value: number
  location: string
  bin: string
  units: number
}

export default {
  mapCoordinates (transfers: TransferData[]): MapCoordinate[] {
    return compact(map(transfers, transfer => {
      const { latitude: lat, longitude: lng } = transfer
      if (!lat || !lng) return null
      return { lat, lng }
    }))
  },

  totalUnits (transfers: TransferData[]): number {
    return sumBy(transfers, transfer => {
      if (!transfer.pallet) return 0
      return transfer.pallet.quantity
    })
  },

  stockOnHandData (
    aliveTransfers: TransferData[]
  ): StockOnHandData[] {
    const groupByItem = groupBy(aliveTransfers, transfer => {
      if (transfer.pallet && transfer.pallet.item) {
        return transfer.pallet.item.code
      }
    })
    const transfers = map(groupByItem, transfers => {
      const groupByLocationAndBin = groupBy(transfers, transfer => {
        return `"${transfer.locationId}${transfer.bin}"`
      })
      return map(groupByLocationAndBin, transfers => {
        const transfer = transfers[0]
        const { pallet } = transfer
        if (!transfer.location) return
        const id = transfer.id
        const item = pallet && pallet.item ? pallet.item.code : ''
        const description = pallet && pallet.item ? pallet.item.description : ''
        const location = transfer.location.name
        const bin = transfer.bin || ''
        const units = this.totalUnits(transfers)
        const value = pallet && pallet.item ? units * pallet.item.value : 0
        const minimumStock = pallet && pallet.item ? pallet.item.minimumStock : 0
        const delta = units - minimumStock
        return {
          id,
          item,
          description,
          value,
          location,
          bin,
          units,
          minimumStock,
          delta
        }
      })
    })
    return compact(flatten(transfers))
  }
}
